import { Box, Skeleton, Typography } from "@mui/material";
import { FormField } from "empower-energy-owner-components";

const FormFieldWithLoader = (props) => {
  if (props.loading) {
    return (
      <Box className="mui-field flex items-center space-between" mb={2}>
        {props.showLabel && (
          <Typography variant="subtitle2" className="mui-field-label">
            {props.formFieldLabel}
          </Typography>
        )}
        <Skeleton
          width="70%"
          animation="wave"
          height="40px"
          variant="rounded"
        />
      </Box>
    );
  } else {
    return <FormField {...props} loading={undefined} />;
  }
};

export default FormFieldWithLoader;
